$(document).ready(function() {
  const buttonSubmitPin = document.querySelector('#submit-pin-code');
	const pinCodes        = document.querySelectorAll('.pin-codes');

	pinCodes.forEach(function(input) {
    input.type = 'number'
    input.setAttribute('onkeypress', "if ((/^[0-9]{1,1}$/.test(this.value))) return false;");
    input.setAttribute('pattern', "[0-9]*");
    input.addEventListener('keyup', filledOtpCode);
  })

  if (buttonSubmitPin) {
    buttonSubmitPin.addEventListener('click', filledOtpCode)
  }

  function filledOtpCode() {
    var pin_codes = ''

    document.querySelectorAll('.pin-codes').forEach(el => {
      if (el.length != 0) {
        pin_codes += el.value
      }
    })

    document.querySelector('#append-pin-code').value = pin_codes
  }
})
